import React from 'react';

const OfferPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-600">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-slate-800 rounded-3xl shadow-xl border border-slate-700 p-8">
          <h1 className="text-3xl text-white mb-2 text-center">
            Публичная оферта
          </h1>
          <div className="text-xl text-slate-300 mb-6 text-center">
            (договор купли-продажи между Продавцом и Покупателем)
          </div>
          <div className="text-slate-400 text-sm mb-8 text-center">
            Дата публикации: 3 июня 2025 г.
          </div>
          
          <div className="space-y-6 text-slate-300 leading-relaxed">
            <div className="space-y-4">
              <p>
                <span className="text-[#7538d5] font-semibold">Продавец:</span> зарегистрированное и верифицированное лицо, размещающее предложение о продаже через платформу "Сделка и Точка" (dealtochka.com, далее — «Продавец»).
              </p>
              
              <p>
                <span className="text-[#7538d5] font-semibold">Покупатель:</span> любое дееспособное физическое лицо, оформившее заказ и произведшее оплату (далее — «Покупатель»).
              </p>
            </div>
            
            <div className="space-y-6">
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">1. Предмет оферты</h2>
                <p>Продавец предлагает Покупателю приобрести товар/услугу: <span className="text-[#7538d5] font-semibold">*Консультация в ИТ*</span> по цене <span className="text-[#7538d5] font-semibold">*50,00 ₽*</span>.</p>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">2. Порядок заключения договора</h2>
                <div className="space-y-3">
                  <p>Договор считается заключённым с момента подтверждения оплаты Покупателем через платёжную систему платформы "Сделка и Точка".</p>
                  <p>После успешной оплаты настоящая оферта автоматически приобретает силу договора между Покупателем и Продавцом.</p>
                  <p>Электронная версия договора будет доступна для скачивания на странице оплаты, а также может быть отправлена на электронную почту Покупателя при её указании.</p>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">3. Порядок исполнения</h2>
                <p>После оплаты Продавец обязуется предоставить товар или оказать услугу в срок и на условиях, указанных в описании на странице товара.</p>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">4. Права и обязанности сторон</h2>
                <div className="space-y-3">
                  <p>Продавец обязуется предоставить достоверную информацию о товаре/услуге и исполнить свои обязательства надлежащим образом.</p>
                  <p>Покупатель обязуется оплатить товар/услугу и предоставить корректные контактные данные.</p>
                  <p>Платформа ФИНСЕТЬ предоставляет техническую возможность совершения сделки и не является стороной договора.</p>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">5. Возврат и споры</h2>
                <div className="space-y-3">
                  <p>Покупатель вправе подать претензию через техническую поддержку платформы.</p>
                  <p>Возврат средств осуществляется в случаях, предусмотренных законодательством РФ и правилами платформы "Сделка и Точка".</p>
                  <p>Споры между Покупателем и Продавцом могут рассматриваться арбитражной комиссией платформы.</p>
                </div>
              </div>
              
              <div>
                <h2 className="text-[#7538d5] font-semibold text-xl mb-4">6. Заключительные положения</h2>
                <div className="space-y-3">
                  <p>Настоящая оферта является юридически обязательным предложением Продавца.</p>
                  <p>Договор заключается в электронной форме и имеет полную юридическую силу.</p>
                  <p>Все данные о совершённой сделке хранятся в системе платформы "Сделка и Точка".</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-6 border-t border-slate-700 text-center">
            <div className="text-slate-400 text-sm">
              ООО "ИКС ДРАЙВ" • ИНН: 7842222864 • КПП: 784201001 • ОГРН: 1247800055436
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferPage;
